<div *ngIf="applicationLoaded; else loadingBlock">
  <div id="banner" class="content-block flex-center-row">
    <h1>{{ applicationName }} Issues</h1>
  </div>
  <div class="content-block">
    <div *ngLet="computeBackupStatus() as status" class="status-text">
      Backup status: <span class="status-text" [ngClass]="status.class">{{ status.text }}</span>
    </div>
    <div *ngLet="computeRestoreStatus() as status" class="status-text">
      Recovery status: <span class="status-text" [ngClass]="status.class">{{ status.text }}</span>
    </div>
    <hr />

    <ng-container *ngLet="backupIssues as bi">
      <div *ngIf="bi.length > 0 || hasEverHadBackupIssues">
        <div class="sticky-issues-header flex-center-row half-margin-bottom">
          <div class="issues-header block-header">
            <h3>Backup Issues</h3>
            <div>Arpio encountered the following issues during your most recent backup.</div>
          </div>
          <ng-container *ngIf="accountService.entitledForCapability('backup') && canManage">
            <button
              type="button"
              busy-button
              [busy]="backingUp"
              [disabled]="backingUp"
              class="arpio-button small-button"
              (click)="launchBackupToTryAgain()"
            >
              RETRY BACKUP
            </button>
          </ng-container>
        </div>
        <button
          class="toggle-all-btn"
          *ngIf="backupIssuesView?.groupedIssues?.length > 0"
          (click)="backupIssuesView.toggleAll()"
        >
          {{ backupIssuesView.allExpanded ? 'Collapse All' : 'Expand All' }}
        </button>
        <issues-view
          #backupIssuesView
          [sync-pair]="application.syncPair"
          [application]="application"
          [issues]="bi"
          [showToggleAll]="false"
        ></issues-view>
        <ng-container *ngIf="bi.length === 0">
          <div *ngIf="!backingUp; else backupIssuesInProgressBlock">All backup issues have been fixed</div>
          <ng-template #backupIssuesInProgressBlock>
            <div>A new recovery point is being created</div>
          </ng-template>
        </ng-container>
        <hr />
      </div>
    </ng-container>

    <ng-container *ngLet="restoreIssues as ri">
      <div *ngIf="ri.length > 0 || hasEverHadRestoreIssues">
        <div class="sticky-issues-header flex-center-row margin-bottom">
          <div class="issues-header block-header">
            <h3>Recovery Environment Issues</h3>
            <div>Arpio encountered the following issues during your most recent recovery.</div>
          </div>
          <ng-container *ngIf="accountService.entitledForCapability('restore') && getRestorePermission()">
            <ng-container *ngIf="canTryAgainFromJob; else retryRecoveryOnly">
              <p-splitButton
                *ngIf="!restoring; else restoringSpinner"
                label="Resume Recovery"
                icon="fa-solid fa-rotate-right"
                dropdownIcon="fa-solid fa-ellipsis-vertical"
                [model]="restoreMenuItems"
                (onClick)="launchRestoreToTryAgain(true)"
              ></p-splitButton>
              <ng-template #restoringSpinner>
                <button type="button" busy-button [busy]="true" disabled class="arpio-button small-button">
                  RESUME RECOVERY
                </button>
              </ng-template>
            </ng-container>
            <ng-template #retryRecoveryOnly>
              <i
                *ngIf="resumeRecoveryUnavailableCause"
                class="fa-solid fa-circle-info resume-recovery-info"
                [pTooltip]="resumeRecoveryUnavailableCause"
                tooltipStyleClass="resume-recovery-tooltip"
              ></i>
              <button
                type="button"
                busy-button
                [busy]="restoring"
                [disabled]="restoring"
                class="arpio-button small-button"
                (click)="launchRestoreToTryAgain(false)"
              >
                RETRY RECOVERY
              </button>
            </ng-template>
          </ng-container>
        </div>
        <button
          class="toggle-all-btn"
          *ngIf="restoreIssuesView?.groupedIssues?.length > 0"
          (click)="restoreIssuesView.toggleAll()"
        >
          {{ restoreIssuesView.allExpanded ? 'Collapse All' : 'Expand All' }}
        </button>
        <issues-view
          #restoreIssuesView
          [sync-pair]="application.syncPair"
          [application]="application"
          [issues]="ri"
          [showToggleAll]="false"
        ></issues-view>
        <ng-container *ngIf="ri.length === 0">
          <div *ngIf="!syncing; else restoreIssuesInProgressBlock">All recovery issues have been fixed</div>
          <ng-template #restoreIssuesInProgressBlock>
            <div>The recovery environment is being updated</div>
          </ng-template>
        </ng-container>
        <hr />
      </div>
    </ng-container>

    <ng-container *ngLet="failbackIssues as fi">
      <div *ngIf="accountService.entitledForCapability('failback') && fi.length > 0">
        <div class="sticky-issues-header flex-center-row">
          <h3 class="issues-header block-header">Failback Issues</h3>
        </div>
        <button
          class="toggle-all-btn"
          *ngIf="failbackIssuesView?.groupedIssues?.length > 0"
          (click)="failbackIssuesView.toggleAll()"
        >
          {{ failbackIssuesView.allExpanded ? 'Collapse All' : 'Expand All' }}
        </button>
        <issues-view
          #failbackIssuesView
          [sync-pair]="application.syncPair"
          [issues]="fi"
          [application]="application"
          [showToggleAll]="false"
        ></issues-view>
        <hr />
      </div>
    </ng-container>
  </div>
</div>

<ng-template #loadingBlock>
  <div class="content-block">
    <h1><i class="fa-solid fa-spinner fa-spin"></i> Loading</h1>
  </div>
</ng-template>
